import { defineMessages } from 'react-intl';

export const notificationUpdatesPickerMessages = defineMessages({
  placeholder: {
    defaultMessage: 'Select updates to receive alerts for',
    id: 'yZ0CgP',
    description: 'Placeholder shown on the shipment updates picker when nothing is selected',
  },
  selectAll: {
    defaultMessage: 'Select All',
    id: 'ueBQL9',
    description: 'Link that checks every shipment update option',
  },
  clearAll: {
    defaultMessage: 'Clear All',
    id: '9XVTPk',
    description: 'Link that unchecks every shipment update option',
  },
  apply: {
    defaultMessage: 'Apply',
    id: 'u895/W',
    description: 'Button that commits the checked shipment updates and closes the picker',
  },
  removeUpdate: {
    defaultMessage: 'Remove {label}',
    id: 'xofpSV',
    description: 'Accessible label for the remove button on a selected shipment-update pill',
  },
});
